import { HRIAClient } from '../client';
import { ApiResponse } from '../types';

export interface LoginPayload {
  email: string;
  password: string;
  deviceId?: string;
}

export interface LoginResponse {
  user: any;
  token: string;
  expiresAt: string;
}

export class AuthAPI {
  constructor(private client: HRIAClient) {}

  login(payload: LoginPayload) {
    return this.client.post<LoginResponse>('/api/v1/auth/login', payload);
  }

  logout() {
    return this.client.post<void>('/api/v1/auth/logout');
  }

  profile() {
    return this.client.get<{ user: any }>('/api/v1/auth/profile');
  }

  refresh() {
    return this.client.post<{ token: string; expiresAt: string }>('/api/v1/auth/refresh-token');
  }
}

export const createAuthAPI = (client: HRIAClient) => new AuthAPI(client);
